module.exports = __webpack_public_path__ + "img/vertical_5_1_9016.1e93a45a.png";